export default "__VITE_ASSET__f8583689__"